export default __webpack_public_path__ + "static/media/logo.1250c4b8.png";